import {openModal} from 'snippets/_containers/modal/modal';

const VARIANT_ID_ATTRIBUTE = 'data-variant-id';

document.querySelectorAll('.oos-notification-button').forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = button.getAttribute(VARIANT_ID_ATTRIBUTE);
        const modal = document.querySelector('.modal--oos-notification');
        if (modal) {
            modal.setAttribute(VARIANT_ID_ATTRIBUTE, variantId);
            openModal(modal);
        }
    });
});
